module.exports = __webpack_public_path__ + "static/media/5_viewer_presenter.2ff7656b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/5_viewer_presenter.mp4
// module id = 317
// module chunks = 0